import "./style.scss";

export const CONTROL_CLASS_NAME = "Field-Control";
